import React from 'react'
import styled from 'styled-components'

import { FONTS } from '../../constants'

export const Tabs = ({ activeTab, handleChangeTab }) => {
  return (
    <Root>
      <Tab
        active={ activeTab === 0 }
        onClick={ () => handleChangeTab(0) }
      >
        AP Paying
      </Tab>
      <Tab
        active={ activeTab === 1 }
        onClick={ () => handleChangeTab(1) }
      >
          AR Billing
      </Tab>
    </Root>
  )
}

const Root = styled.div`
    height: 40px;
    display: flex;
    align-items: center;
    background: white;
`

const Tab = styled.div`
    width: auto;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-family: ${p => (p.active ? FONTS.GOTHAM_BOLD : FONTS.GOTHAM)};
    font-size: ${FONTS.NORMAL_SIZE};
    margin: 0 16px;
    color: ${p => (p.active ? '#AD2624' : '#808080')};
    border-bottom: ${p => (p.active ? '4px solid #AD2624' : 'none')};

    ${p => (p.active === 'true' && `
        margin-bottom: -4px;
    `)}
`



// WEBPACK FOOTER //
// ./src/components/accounting-dashboard/tabs.js